import React from 'react'
import PropTypes from 'prop-types'
import SectionHeader from 'components/molecules/SectionHeader'
import PSPMarkdownContent from 'components/molecules/PSPMarkdown/PSPMarkdownContent'
import Container from 'components/core/Page/Container'
import './ContentSectionModule.scss'

const ContentSectionModule = ({ title, description = "", content = [], background, isColumnWise , listType="normal"}) => {
    const BG_COLOR_MAP = {
        "light-blue": "light-blue-bg",
        blue: "blue-bg",
        white: "white-bg",
        default: "light-blue-bg",
    };
    const textColorMap = {
        "light-blue": "black",
        blue: "white",
        white: "black",
        default: "black",
    }

    return (
        <section className="content-section-module">
            <div className={BG_COLOR_MAP[background] || BG_COLOR_MAP.default}>
                <Container>
                    <SectionHeader
                        title={title}
                        description={description}
                        contentAlign="text-left"
                        titleProps={{
                            size: "xxlarge",
                            weight: "bold",
                            style: { padding: 0, color: textColorMap[background] || textColorMap.default, lineHeight: "32px", margin: "0 0 16px 0" }
                        }}
                        className="title"
                        additionalProps={{
                            paragraph: {
                                size: "standard",
                                color: textColorMap[background] || textColorMap.default,
                                weight: "regular",
                                style: { padding: 0, margin: "0" }
                            }
                        }}
                        isPageContainer={false}
                    />
                    <div className={(isColumnWise ? `contents row-wise` : `contents column-wise ${listType}`)}>
                        {
                            content.map((paragraph) => 
                                   <PSPMarkdownContent
                                    content={paragraph.value}
                                    key={paragraph.id}
                                    className='content'
                                    additionalProps={{
                                        paragraph: {
                                            size: "standard",
                                            color: "black",
                                            weight: "regular",
                                            style: {color: textColorMap[background] || textColorMap.default }
                                        },
                                        li: {
                                            size: "standard",
                                            color: "black",
                                            weight: "regular",
                                            style: { color: textColorMap[background] || textColorMap.default }
                                        }
                                    }}
                                />
                            )
                        }
                    </div>
                </Container>
            </div>
        </section>
    )
}

ContentSectionModule.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    content: PropTypes.arrayOf(PropTypes.object),
    background: PropTypes.string,
    isColumnWise: PropTypes.bool, // isColumnWise - INVERTED: true = row layout, false = column layout
    listType: PropTypes.oneOf(["normal", "single"])
}

export default ContentSectionModule;
